export default {
  services: {
    account: {
      name: 'Аккаунт сервис'
    }
  }
}